// extracted by css-extract-rspack-plugin
export default {"cls1":"BigCardDiscover-cls1_mqR","cls2":"BigCardDiscover-cls2_xn0 BigCardDiscover-cls1_mqR"};